import React from "react";
import { Icon } from "@shared/components/Molecules/Icon/Icon.component";
import { IconNames } from "@shared/enums/icons.enums";
import { cn } from "@shared/helpers/classNames.helper";
import S from "./Chip.module.scss";

interface ChipProps {
    label: string;
    removable?: boolean;
    onRemove?: () => void;
    className?: string;
    size?: "default" | "small";
}

export const Chip: React.FC<ChipProps> = ({
    label,
    removable,
    onRemove,
    className,
    size = "default",
}) => {
    return (
        <div className={cn(S.chip, className, { [S.small]: size === "small" })}>
            {removable && (
                <button className={S.removeButton} onClick={onRemove}>
                    <Icon iconName={IconNames.Close} className={S.closeIcon} />
                </button>
            )}
            <span className={S.label}>{label}</span>
        </div>
    );
};
